export const ROOT_BREADCRUMB_VALUE = 'breadcrumbs.root';
